import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { LOGO_URL } from "@/lib/constants";

export const Footer = () => {
  return (
    <footer className="py-8 px-4 border-t border-slate-800" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 mb-6">
          <div className="flex items-center gap-4">
            <img
              src={LOGO_URL}
              alt="DATYON - Analista de Datos"
              className="h-8 w-auto"
            />
            <div className="flex items-center gap-2 text-slate-400">
              <MapPin className="w-4 h-4 text-indigo-400" />
              <span className="text-sm">Murcia, España</span>
            </div>
          </div>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-slate-500 hover:text-white text-sm transition-colors">Inicio</Link>
            <Link to="/servicios" className="text-slate-500 hover:text-white text-sm transition-colors">Servicios</Link>
            <Link to="/blog" className="text-slate-500 hover:text-white text-sm transition-colors">Blog</Link>
            <Link to="/contacto" className="text-slate-500 hover:text-white text-sm transition-colors">Contacto</Link>
          </div>
        </div>

        <div className="flex flex-wrap justify-center md:justify-start gap-4 mb-6 pt-4 border-t border-slate-800">
          <Link to="/aviso-legal" className="text-slate-500 hover:text-white text-sm transition-colors">Aviso Legal</Link>
          <span className="text-slate-700">|</span>
          <Link to="/politica-privacidad" className="text-slate-500 hover:text-white text-sm transition-colors">Política de Privacidad</Link>
          <span className="text-slate-700">|</span>
          <Link to="/politica-cookies" className="text-slate-500 hover:text-white text-sm transition-colors">Política de Cookies</Link>
        </div>

        <p className="text-slate-500 text-sm text-center md:text-left">
          &copy; {new Date().getFullYear()} DATYON - Antonio Oliver. Todos los derechos reservados.
        </p>
      </div>
    </footer>
  );
};
